/* React Higher Order Component which fetches course saves for course where shortCourseId = props.shortCourseId. Saves data will refresh via poll and pass changes via props
    child will receive props: {
        saves: PropTypes.array
        onTogglePoll: PropTypes.func
    }
*/

import React from 'react';
import PropTypes from 'prop-types';

const ShortCourseActions = require('../../actions/ShortCourseActions');
const ShortCourseStore = require('../../stores/ShortCourseStore');
const PermissionsUtil = require('../../../../app/shared/PermissionsUtil');
const ReactUtil = require('../../util/ReactUtil');

const propTypes = {
    shortCourseId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    channelStoreState: PropTypes.shape({ channel: PropTypes.shape({ user_permissions: PropTypes.object.isRequired }) }).isRequired,
    projectStoreState: PropTypes.shape({ project: PropTypes.shape({ user_permissions: PropTypes.object.isRequired }) }).isRequired,
    documentVisible: PropTypes.bool.isRequired,
    disablePolling: PropTypes.bool,
};
const defaultProps = {
    disablePolling: false,
};
const POLL_ACTION_ID = 'course-saves-poll';

export default function withShortCourseSavesPoll(WrappedComponent) {
    class WithShortCourseSavesPoll extends React.Component {
        constructor(props) {
            super(props);

            this.state = {
                saves: ShortCourseStore.getStateShortCourse(
                        props.shortCourseId,
                        props.projectId,
                        props.channelId
                    ).saves,
                disablePolling: false,
                fatalError: null
            }

            this.refreshSavesData = this.refreshSavesData.bind(this);
            this.onTogglePolling = this.onTogglePolling.bind(this);
            this.unsubscribes = [ShortCourseStore.listen(this.onShortCourseStoreChange.bind(this))];
        }

        componentDidMount() {
            const self = this;
            this.refreshSavesData(true);
            this.updateSavesInterval = window.setInterval(self.refreshSavesData, 60000);
        }

        componentWillUnmount() {
            window.clearInterval(this.updateSavesInterval);
            this.unsubscribes.forEach(u => u());
        }

        onShortCourseStoreChange(newState) {
            this.setState({
                saves: ShortCourseStore.getStateShortCourse(
                    this.props.shortCourseId,
                    this.props.projectStoreState.shortCourseProject.id,
                    this.props.channelStoreState.channel.id
                    ).saves,
            });
        }

        refreshSavesData(init=false) {
            if (
                !init
                && (
                    !this.props.documentVisible
                    || this.props.disablePolling
                    || this.state.disablePolling
                )
            ) {
                return;
            }

            const project = this.props.projectStoreState.shortCourseProject;
            const channel = this.props.channelStoreState.channel;
            if (
                !project
                || !channel
                || !PermissionsUtil.canViewShortCourses(channel.user_permissions, project.user_permissions)
            ) {
                return;
            }

            ShortCourseActions.getShortCourseSaves(
                POLL_ACTION_ID,
                { shortCourseId: this.props.shortCourseId }
            );
        }

        onTogglePolling(pollBool) {
            this.setState({ disablePolling: pollBool });
        }

        render() {
            if (!this.state.saves) {
                return null;
            }

            return (
                <WrappedComponent
                    {...this.props}
                    saves={this.state.saves}
                    onTogglePoll={this.onTogglePolling}
                />
            );
        }
    }

    WithShortCourseSavesPoll.propTypes = propTypes;
    WithShortCourseSavesPoll.defaultProps = defaultProps;
    WithShortCourseSavesPoll.displayName = `WithShortCourseSavesPoll(${ReactUtil.getComponentDisplayName(WrappedComponent)})`
    return WithShortCourseSavesPoll;
}
